module.exports = __webpack_public_path__ + "img/event-view-003.c65fb79c.jpg";